/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { NotaryAPI } from '../api/notary/types';

export const isGroupAdmin = (permissions: NotaryAPI.BSRPermissions[]) => {
  return permissions && permissions.includes(NotaryAPI.BSRPermissions.BSRAdmin);
};
